import { initialize } from 'launchdarkly-js-client-sdk';

export default defineNuxtPlugin(async () => {
  const config = useRuntimeConfig();

  const user = {
    anonymous: config.public.launchDarkly.anonymous,
    key: config.public.launchDarkly.user,
  };

  const ldClient = initialize(config.public.launchDarkly.clientId, user);
  await ldClient.waitUntilReady();

  return {
    provide: {
      ldClient,
    },
  };
});
